import { render, staticRenderFns } from "./salesQuick.vue?vue&type=template&id=c85a3996&"
import script from "./salesQuick.vue?vue&type=script&lang=js&"
export * from "./salesQuick.vue?vue&type=script&lang=js&"
import style0 from "./salesQuick.vue?vue&type=style&index=0&id=c85a3996&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports